<template>
  <zul-modal id="terms-modal" class="is-medium" ref="modal" title="Termos de uso" :secondary="'Fechar'" @secondary="close()">

    <div v-if="showLoader">
      <div class="loading">
        Carregando...
      </div>
    </div>

    <div v-else>
      <p v-html="terms"></p>
    </div>

  </zul-modal>
</template>

<script>
export default {
  props: {},
  data () {
    return {
      showLoader: true,
      terms: null
    }
  },
  mounted () {
    this.$root.$on('open-terms-modal', (type) => {
      if (type) {
        this.loadTerms(type)
        this.$refs.modal.open()
      }
    })
    this.$root.$on('close-terms-modal', () => {
      this.close()
    })
    //this.$root.$on('reset-terms-modal', this.reset)
  },
  destroyed () {
    this.$root.$off('open-terms-modal')
    this.$root.$off('close-terms-modal')
    this.$root.$off('reset-terms-modal')
  },
  methods: {
    loadTerms (type) {
      this.showLoader = true
      this.terms = null
      this.$http.get('/terms/' + type).then(res => {
        this.terms = res.data.text
        this.showLoader = false
      })
    },
    next () {
      this.step++
      this.$refs.modal.setProps({ labels: { primary: 'Avançar' } })
    },

    validate() {
      this.$validator.validateAll().then( (/* result */) => {
      })
    },

    close () {
      this.$refs.modal.close()
    }
  },
  components: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import '../assets/sass/variables';

  .loading {
    background: url('../assets/loading.svg') no-repeat center 35%;
    background-size: 100px;
    text-align: center;
    padding: 7rem 0 0;
    font-size: $size-7;
    opacity: .5;
    margin-right: 0;
  }

</style>